<div role="complementary">
  <button
    mat-mini-fab
    aria-label="Scroll to top"
    class="nsc-scroll-to-top"
    color="warn"
    [class.nsc-scroll-to-top--visible]="show.button"
    (click)="scrollToTop()"><mat-icon>file_upload</mat-icon></button>
</div>
